import React, { Fragment } from "react";
import { useParams } from "react-router-dom";
import blogData from "../data/blog-detail.json";
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import { HeaderThree, BlogSingle, FooterTwo } from "../containers";

const BlogDetails = () => {
  const { slug } = useParams();

  const blog = blogData.find(
    (b) =>
      b.title
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "") === slug
  );

  if (!blog) {
    return (
      <Fragment>
        <HeaderThree />
        <Breadcrumb
          pageName="Blog Not Found"
          bgImage="/images/breadcumb/breadcumb-bg.jpg"
        />
        <div className="container text-center py-5">
          <h2>Blog not found</h2>
          <p>The blog you are looking for does not exist.</p>
        </div>
        <FooterTwo />
        <ScrollTopBtn />
      </Fragment>
    );
  }

  const canonicalUrl = `https://www.techayukta.com/blog/${slug}`;

  return (
    <Fragment>
      <Seo
        title={`${blog.title} | Tech Ayukta`}
        description={
          blog.content.length > 150
            ? blog.text.substring(0, 150) + "..."
            : blog.text
        }
        keywords={`${blog.title}, Tech Ayukta Blog, ${blog.author}, ERP Solutions, Software Development, IT Consulting`}
        canonical={canonicalUrl}
      />

      <HeaderThree />
      <Breadcrumb
        pageName={blog.title}
        bgImage="/images/breadcumb/breadcumb-bg.jpg"
      />
      <BlogSingle blog={blog} className="space-top space-extra-bottom" />
      <FooterTwo />
      <ScrollTopBtn />
    </Fragment>
  );
};

export default BlogDetails;
